import React from "react";
import PhoneInput from "antd-phone-input";

function KoMobile(props){
  return(
    <PhoneInput enableSearch {...props}/>
  );
}

export default KoMobile;